<template>
<div class="select-subject-wrapper">
  <el-form :model="form" ref="form" label-width="80px" class="form">
    
    <el-form-item label="科目">
      <el-checkbox-group v-model="form.selectedSubjects">
        <template v-for="item in subjects">
          <el-checkbox :key="item.shortName" :label="item.shortName" name="selectedSubjects" />
        </template>
      </el-checkbox-group>
    </el-form-item>
    
    <el-form-item label="大学">
      <Search :datas="colleges" :searchWord.sync="form.college" placeHolder="请输入大学" />
    </el-form-item>

    <el-form-item label="年">
      <el-select v-model="form.year" placeholder="请选择年">
        <el-option label="无限制" value="" />
        <template v-for="item in years">
          <el-option :key="item" :label="item" :value="item" />
        </template>  
      </el-select>
    </el-form-item>

    <el-form-item label="区域">
      <el-select v-model="form.region" placeholder="请选择区域">
        <el-option label="无限制" value="" />
        <template v-for="item in regions">
          <el-option :key="item" :label="item" :value="item" />
        </template>  
      </el-select>
    </el-form-item>

    <el-form-item label="专业层次">
      <el-select v-model="form.grade" placeholder="请选择专业层次">
        <el-option label="无限制" value="" />
        <template v-for="item in grades">
          <el-option :key="item" :label="item" :value="item" />
        </template>  
      </el-select>
    </el-form-item>

    <el-form-item>
      <el-button type="primary" @click="submit">查询</el-button>
    </el-form-item>

  </el-form>

  <!-- 分页导航 -->
  <div class = "pager">
    <el-pagination
      @size-change="sizeChange"
      @current-change="currentChange"
      :current-page.sync="page.currentPage"
      :page-sizes="[50,100]"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next"
      :total="page.totalRecord">
    </el-pagination>
  </div>

  <el-table
    :data="datas"
    style="width: 100%"
    highlight-current-row
    >
    <el-table-column label="大学">
      <template slot-scope="scope">
        <el-link :href="scope.row.website" target="_blank">{{scope.row.college_name}}</el-link>
      </template>
    </el-table-column>

    <el-table-column prop="college_name" label="大学"></el-table-column>
    <el-table-column prop="year" label="年"></el-table-column>
    <el-table-column prop="major_name" label="专业"></el-table-column>
    <el-table-column prop="region" label="区域"></el-table-column>
    <el-table-column prop="grade" label="专业层次"></el-table-column>
    <el-table-column prop="major_name" label="专业"></el-table-column>
    <el-table-column prop="subject_constraint" label="科目限制"></el-table-column>
  </el-table>

</div>
</template>

<script>
import {mapState} from 'vuex'
import Search from '@com/common/search'

export default {
  name: 'SelectSubject',
  data () {
    return {
      form:{
        selectedSubjects:[],
        year: '',
        region: '',
        grade: '',
        college: ''
      },
      page: {
        pageSize: 100, //每页条数,  默认100条
        totalRecord: 0, //总条数
        totalPage: 0, //总页数
        currentPage:1  //当前显示页码
      },
      datas:[],
      years: [],
      regions: [],
      grades: []
    }
  },
  computed: {
    // 将vuex中的全局变量subjects映射为组件的局部变量
    ...mapState({
      subjects: 'subjects',
      colleges: 'colleges'
    }),
  },
  components: {
    Search
  },
  mounted(){
    this.loadOption()
  },
  methods: {
    submit(){
      if(this.form.selectedSubjects.length!=3){
        this.$message('需要选择3个科目')
        return
      }
      this.loadData()
    },
    loadData(){
      const that = this
      let params = {
        'currentpage': that.page.currentPage,
        'pagesize': that.page.pageSize
      }
      if(that.form.college.length>0){
        params['college'] = that.form.college
      }
      if(that.form.year>0){
        params['year'] = that.form.year
      }
      if(that.form.region.length>0){
        params['region'] = that.form.region
      }
      if(that.form.grade.length>0){
        params['grade'] = that.form.grade
      }
      if(that.form.selectedSubjects.length>0){
        let subjectsStr = ''
        that.form.selectedSubjects.forEach(element => {
          subjectsStr += element + ',' 
        });
        subjectsStr = subjectsStr.substring(0, subjectsStr.length-1)
        params['subjects'] = subjectsStr
      }
      that.axios.get('/homepage/selectsubject/listbypage', {params})
      .then((ret)=>{
        let {code,message,data} = ret
        if(code===0){
          that.datas = data.list;
          that.page.totalRecord = data.totalRecord  //总条数
          that.page.totalPage = data.totalPage    //总页数
        }else{
          that.$message('查询失败')
          that.$message(message)
        }
      })
    },
    loadOption(){
      const that = this
      that.axios.get('/homepage/selectsubject/majoroptions')
      .then((ret)=>{
        let {code,message,data} = ret
        if(code===0){
          that.regions = data.regions
          that.years = data.years
          that.grades = data.grades
        }else{
          that.$message('查询失败')
          that.$message(message)
        }
      })
    },
    // 修改每页记录数
    sizeChange(val) {
      this.page.pageSize = val
      this.loadData()
    },
    //翻页
    currentChange(val) {
      this.page.currentPage=val
      this.loadData()
    },
  }
}
</script>

<style lang="stylus" scoped>
.select-subject-wrapper
  margin: 40px 40px 50px 40px
  .form
    width: 40%
</style>
